import React, { FC } from 'react'
import { useParams } from 'react-router-dom'
import { makeStyles } from 'tss-react/mui'
import { format } from '@e3dc-react/shell/Libs/date'

import CollapsedPaper from './CollapsedPaper'
import { Battery } from 'src/Types/responses/storages/serialNo/hardware/batteries'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { ApiView } from '@e3dc-react/shell/Elements/ApiView'
import { ApiTableColumn, FetchProps } from '@e3dc-react/shell/Elements/ApiView/ApiView'

const useStyles = makeStyles()(theme => ({
  tableHeader: {
    borderBottom: '2px solid rgba(224, 224, 224, 1)',
  },
}))

/**
 * Component to display batteries configuration of selected system (dcbconfiguration).
 */
const Batteries: FC = () => {
  const { storageId } = useParams<{ installationId: string; storageId: string }>()
  const { t } = useCustomTranslation()
  const { classes } = useStyles()

  const fetchProps: FetchProps = {
    url: `storages/${storageId}/hardware/batteries`,
    orderBy: '+bat_index,+rack_index,+DCBAddr',
  }

  const columns: ApiTableColumn<Battery>[] = [
    {
      name: 'iSerialNumber',
      label: t('common.serialnumber'),
      value: item => item.iSerialNumber,
    },
    {
      name: 'bat_index',
      label: t('common.battery'),
      value: item => item.bat_index,
    },
    {
      name: 'rack_index',
      label: t('installation-statement.rack'),
      value: item => item.rack_index,
    },
    {
      name: 'DCBAddr',
      label: t('common.module'),
      value: item => item.DCBAddr,
    },
    {
      name: 'tcManufacurerName',
      label: t('installation-statement.bidi.vehicleManufacturer'),
      value: item => item.tcManufacurerName,
    },
    {
      name: 'tcDeviceName',
      label: t('common.type'),
      value: item => item.tcDeviceName,
    },
    {
      name: 'time',
      label: t('systemSettings.battery.overview.production-date'),
      value: item => item.time && format(item.time, t('common.format.date-fns-date')),
    },
    {
      name: 'iFWVersion',
      label: t('systemSettings.battery.overview.firmwareVersion'),
      value: item => item.iFWVersion,
    },
  ]

  return (
    <CollapsedPaper title={t('installation-statement.images.types.batteries')}>
      <ApiView<Battery>
        fetchProps={fetchProps}
        tableColumns={columns}
        hasColoredTableColumns
        bodyElevation={0}
        footerElevation={0}
        headerElevation={0}
        headerClassName={classes.tableHeader}
        listProps={{
          primary: (battery: Battery) => battery.serialno,
          secondary: (battery: Battery) => battery.tcDeviceName,
        }}
      />
    </CollapsedPaper>
  )
}

export default Batteries
